import { Box, Container } from '@mui/material'
import { HeaderWithActions, InitializationWrapper } from '@planning/components'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { useAsyncFetch } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'

import { usePlanningStore } from '@planning/AppProvider'
import { useMemo } from 'react'
import { Helmet } from 'react-helmet-async'
import { HoldOverrideDialog } from '@planning/components/hold/molecules/HoldOverrideDialog'
import { HoldsResolveDialog } from './molecules/HoldsResolveDialog'
import { HoldsTable } from './organisms/HoldsTable'
import { HoldsViewStore } from './stores/HoldsViewStore'

export const HoldsPage = observer(() => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()
  const { holdItemStore, containerJourneyItemStore, containerItemStore } = usePlanningStore()

  const viewStore = useMemo(
    () => new HoldsViewStore(holdItemStore, containerJourneyItemStore, containerItemStore),
    [holdItemStore, containerJourneyItemStore, containerItemStore],
  )

  const { loading } = useAsyncFetch(async () => {
    await viewStore.fetch()
  }, [viewStore])

  const title = t('holds', 'Holds')

  return (
    <InitializationWrapper isInitializing={loading}>
      <Box sx={{ bgcolor: theme.palette.grey[100], minHeight: '100vh' }}>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <HeaderWithActions title={title} noMarginBottom actions={[]} />
        <Container sx={{ paddingY: 2 }}>
          <HoldsTable viewStore={viewStore} />
          <HoldsResolveDialog viewStore={viewStore} />
          <HoldOverrideDialog
            open={viewStore.isOverrideDialogOpen}
            onClose={viewStore.closeOverrideDialog}
            onConfirm={(types, reason) => viewStore.override(types, reason)}
            holdTypeName={viewStore.selectedOverrideContext?.holdTypeName}
            containerNumber={viewStore.selectedOverrideContext?.containerNumber}
            restrictions={viewStore.selectedOverrideContext?.blockRestrictions}
          />
        </Container>
      </Box>
    </InitializationWrapper>
  )
})
